import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { fetchData } from '../lib/apis';
import '../css/home-dashboard.css';

const CHANNEL_ASSETS = {
  facebook: require('../img/menu/new_icons/icon-fanpage.png'),
  zalo: require('../img/menu/new_icons/icon-zalo.png'),
  webchat: require('../img/menu/new_icons/icon-webchat.png'),
  telegram: require('../img/menu/new_icons/icon-telegram.png'),
  whatsapp: require('../img/menu/new_icons/icon-whatapps.png')
};

const EMPTY_SUMMARY = {
  metrics: {
    total_customers: 0,
    conversations_today: 0,
    waiting: 0,
    new_customers: 0,
    ai_handled: 0,
    ai_rate: 0
  },
  series: [],
  channels: [],
  recent_activity: [],
  setup: {
    ai_agent: false,
    facebook: false,
    zalo: false,
    staff: false
  }
};

const ACTIONS = [
  {
    key: 'ai_agent',
    title: 'Thiết lập AI Agent',
    description: 'Cấu hình kiến thức và cách Agent phản hồi',
    link: '/ai-chatbot',
    icon: 'AI',
    tone: 'ai'
  },
  {
    key: 'facebook',
    title: 'Kết nối Facebook',
    description: 'Nhận tin nhắn và bình luận từ Fanpage',
    link: '/channel/fanpage',
    iconSrc: CHANNEL_ASSETS.facebook,
    tone: 'facebook'
  },
  {
    key: 'zalo',
    title: 'Kết nối Zalo',
    description: 'Thêm tài khoản Zalo vào tổng đài',
    link: '/channel/zalo',
    iconSrc: CHANNEL_ASSETS.zalo,
    tone: 'zalo'
  },
  {
    key: 'staff',
    title: 'Mời nhân viên',
    description: 'Phân công người phụ trách hội thoại',
    link: '/staff',
    icon: '+',
    tone: 'staff'
  }
];

const TYPE_LABELS = {
  facebook: 'Facebook',
  zalo: 'Zalo',
  webchat: 'Website',
  telegram: 'Telegram',
  whatsapp: 'WhatsApp'
};

const formatNumber = (value) => new Intl.NumberFormat('vi-VN').format(Number(value) || 0);

const formatRelativeTime = (timestamp) => {
  if (!timestamp) return 'Chưa có thời gian';
  const difference = Date.now() - timestamp;
  const minutes = Math.max(1, Math.floor(difference / 60000));
  if (minutes < 60) return `${minutes} phút trước`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} giờ trước`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} ngày trước`;
  return new Date(timestamp).toLocaleDateString('vi-VN');
};

const AgentNetwork = () => (
  <svg className="home-agent-network" viewBox="0 0 440 194" role="img" aria-label="Facebook, Zalo, Chat website, Telegram và WhatsApp kết nối vào AI Agent">
    <defs>
      <pattern id="homeDotPattern" width="12" height="12" patternUnits="userSpaceOnUse">
        <circle cx="1" cy="1" r="1" fill="#d9e1ee" />
      </pattern>
    </defs>
    <rect x="0" y="0" width="440" height="194" fill="url(#homeDotPattern)" />
    <g className="home-agent-network__lines" fill="none" stroke="#9db9f5" strokeWidth="1.5">
      <path d="M54 21 H128 Q148 21 148 52 V76" />
      <path d="M54 59 H130 Q148 59 148 78" />
      <path d="M54 97 H148" />
      <path d="M54 135 H130 Q148 135 148 116" />
      <path d="M54 173 H128 Q148 173 148 142 V118" />
      <path d="M226 97 H300 Q316 97 316 76 V58 H370" />
      <path d="M226 97 H300 Q316 97 316 118 V136 H370" />
    </g>
    <g className="home-agent-network__node">
      <rect x="146" y="58" width="82" height="78" rx="17" fill="#1768e5" />
      <text x="187" y="104" textAnchor="middle" fill="#fff" fontSize="21" fontWeight="700">AI</text>
    </g>
    <g fill="#fff" stroke="#d9e2f0" strokeWidth="1.5">
      <rect x="14" y="3" width="40" height="36" rx="9" />
      <rect x="14" y="41" width="40" height="36" rx="9" />
      <rect x="14" y="79" width="40" height="36" rx="9" />
      <rect x="14" y="117" width="40" height="36" rx="9" />
      <rect x="14" y="155" width="40" height="36" rx="9" />
      <rect x="368" y="39" width="58" height="38" rx="10" />
      <rect x="368" y="117" width="58" height="38" rx="10" />
    </g>
    <g className="home-agent-network__channels">
      <image x="22" y="10" width="24" height="24" xlinkHref={CHANNEL_ASSETS.facebook} />
      <image x="22" y="48" width="24" height="24" xlinkHref={CHANNEL_ASSETS.zalo} />
      <image x="22" y="86" width="24" height="24" xlinkHref={CHANNEL_ASSETS.webchat} />
      <image x="22" y="124" width="24" height="24" xlinkHref={CHANNEL_ASSETS.telegram} />
      <image x="22" y="162" width="24" height="24" xlinkHref={CHANNEL_ASSETS.whatsapp} />
    </g>
    <g fill="#1768e5" fontSize="13" fontWeight="700" textAnchor="middle">
      <text x="397" y="63">CRM</text>
      <text x="397" y="141">24/7</text>
    </g>
  </svg>
);

const EmptyChart = () => (
  <div className="home-chart-empty">
    <div className="home-chart-empty__visual" aria-hidden="true">
      <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
    </div>
    <div className="home-chart-empty__content">
      <strong>Biểu đồ đang chờ những hội thoại đầu tiên</strong>
      <span>Kết nối một kênh để bắt đầu ghi nhận dữ liệu theo ngày.</span>
    </div>
  </div>
);

const ActivityEmpty = () => (
  <div className="home-activity-empty">
    <div className="home-activity-empty__icon" aria-hidden="true">
      <i></i><i></i><i></i>
    </div>
    <strong>Chưa có hoạt động khách hàng</strong>
    <span>Hội thoại mới sẽ xuất hiện tại đây sau khi bạn kết nối kênh.</span>
  </div>
);

export default class HomeDashboard extends Component {
  state = {
    loading: true,
    error: false,
    summary: EMPTY_SUMMARY
  };

  componentDidMount() {
    this.loadSummary();
  }

  componentDidUpdate(prevProps) {
    const previousCompany = prevProps.companySelected && prevProps.companySelected.company_id;
    const currentCompany = this.props.companySelected && this.props.companySelected.company_id;
    if (previousCompany !== currentCompany) this.loadSummary();
  }

  loadSummary = async () => {
    this.setState({ loading: true, error: false });
    try {
      const response = await fetchData({ url: 'api/v1/dashboard/summary' });
      this.setState({
        loading: false,
        summary: response && response.data ? response.data : EMPTY_SUMMARY
      });
    } catch (err) {
      this.setState({ loading: false, error: true, summary: EMPTY_SUMMARY });
    }
  };

  renderChart = (series) => {
    const values = series.reduce((result, item) => result.concat([item.conversations || 0, item.ai || 0]), []);
    const maximum = Math.max.apply(null, values.concat([0]));
    if (!maximum) return <EmptyChart />;

    const width = 700;
    const height = 230;
    const left = 42;
    const right = 16;
    const top = 18;
    const bottom = 40;
    const plotWidth = width - left - right;
    const plotHeight = height - top - bottom;
    const step = plotWidth / Math.max(series.length, 1);
    const y = (value) => top + plotHeight - ((value || 0) / maximum) * plotHeight;
    const aiPoints = series.map((item, index) => `${left + step * index + step / 2},${y(item.ai)}`).join(' ');

    return (
      <div className="home-chart-wrap">
        <svg className="home-chart" viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Biểu đồ hội thoại trong 7 ngày gần nhất">
          {[0, 0.33, 0.66, 1].map((part) => {
            const gridY = top + plotHeight - (part * plotHeight);
            return <line key={part} x1={left} y1={gridY} x2={width - right} y2={gridY} className="home-chart__grid" />;
          })}
          {series.map((item, index) => {
            const barHeight = Math.max(2, ((item.conversations || 0) / maximum) * plotHeight);
            const x = left + step * index + (step - 34) / 2;
            return (
              <g key={item.date || index}>
                <rect className="home-chart__bar" x={x} y={top + plotHeight - barHeight} width="34" height={barHeight} rx="5" />
                <text className="home-chart__label" x={left + step * index + step / 2} y={height - 12} textAnchor="middle">{item.label}</text>
              </g>
            );
          })}
          <polyline className="home-chart__line" points={aiPoints} />
          {series.map((item, index) => (
            <circle key={`point-${item.date || index}`} className="home-chart__point" cx={left + step * index + step / 2} cy={y(item.ai)} r="4" />
          ))}
        </svg>
      </div>
    );
  };

  render() {
    const { loading, error, summary } = this.state;
    const metrics = { ...EMPTY_SUMMARY.metrics, ...(summary.metrics || {}) };
    const setup = { ...EMPTY_SUMMARY.setup, ...(summary.setup || {}) };
    const completed = ACTIONS.filter((item) => setup[item.key]).length;
    const sevenDayTotal = (summary.series || []).reduce((total, item) => total + (item.conversations || 0), 0);
    const dataLevel = metrics.total_customers === 0 && sevenDayTotal === 0
      ? 'empty'
      : (metrics.total_customers < 20 || sevenDayTotal < 10 ? 'sparse' : 'active');
    const user = this.props.UserLogin || {};
    const accountName = user.fullname || user.full_name || user.name || user.username || 'bạn';
    const today = new Date().toLocaleDateString('vi-VN', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' });
    const cards = [
      { label: 'Hội thoại hôm nay', value: metrics.conversations_today, icon: 'far fa-comment-alt', note: metrics.conversations_today ? 'Đang được theo dõi theo thời gian thực' : 'Chưa phát sinh hôm nay' },
      { label: 'Đang chờ phản hồi', value: metrics.waiting, icon: 'far fa-hourglass', note: metrics.waiting ? 'Cần đội ngũ xử lý' : 'Không có hội thoại tồn đọng' },
      { label: 'Khách hàng mới', value: metrics.new_customers, icon: 'far fa-user-plus', note: metrics.new_customers ? 'Ghi nhận trong hôm nay' : 'Chưa có khách hàng mới' },
      { label: 'AI đã xử lý', value: metrics.ai_handled, icon: 'far fa-robot', note: metrics.conversations_today ? `${metrics.ai_rate}% hội thoại hôm nay` : 'Sẵn sàng sau khi bật AI Agent' }
    ];

    return (
      <main className={`home-dashboard home-dashboard--${dataLevel}`}>
        <div className="home-dashboard__inner">
          <header className="home-heading">
            <div>
              <p className="home-heading__eyebrow">Tổng quan vận hành</p>
              <h1>Chào buổi sáng, {accountName}</h1>
              <p className="home-heading__date">{today}</p>
            </div>
            <Link className="home-heading__chat" to="/chat">
              <i className="far fa-comment-dots" aria-hidden="true"></i>
              Mở tổng đài chat
            </Link>
          </header>

          {error && (
            <div className="home-data-alert" role="status">
              <span>Chưa tải được số liệu mới nhất. Các thao tác thiết lập vẫn dùng bình thường.</span>
              <button type="button" onClick={this.loadSummary}>Thử lại</button>
            </div>
          )}

          <section className="home-onboarding" aria-labelledby="home-onboarding-title">
            <div className="home-onboarding__content">
              <p className="home-onboarding__kicker">{completed === ACTIONS.length ? 'Hệ thống đã sẵn sàng' : 'Thiết lập ban đầu'}</p>
              <h2 id="home-onboarding-title">{dataLevel === 'empty' ? 'Bắt đầu vận hành cùng AI' : 'Hoàn thiện hệ thống tương tác đa kênh'}</h2>
              <p>{dataLevel === 'empty'
                ? 'Kết nối kênh đầu tiên và cấu hình Agent. Dashboard sẽ tự lấp đầy bằng dữ liệu thật khi có hội thoại.'
                : 'Bạn đã có dữ liệu vận hành. Hoàn thiện các bước còn lại để AI và đội ngũ phối hợp tốt hơn.'}</p>
              <div className="home-progress-row">
                <strong>{completed}/{ACTIONS.length} bước</strong>
                <div className="home-progress" aria-label={`Đã hoàn thành ${completed} trên ${ACTIONS.length} bước`}>
                  <span style={{ width: `${(completed / ACTIONS.length) * 100}%` }}></span>
                </div>
                {completed < ACTIONS.length && <Link to={ACTIONS.find((item) => !setup[item.key]).link}>Làm bước tiếp theo <i className="far fa-arrow-right" aria-hidden="true"></i></Link>}
              </div>
            </div>
            <AgentNetwork />
          </section>

          <section className="home-metrics" aria-label="Chỉ số hôm nay">
            {cards.map((card) => (
              <article className="home-metric" key={card.label}>
                <div className="home-metric__icon"><i className={card.icon} aria-hidden="true"></i></div>
                <div>
                  <p>{card.label}</p>
                  <strong>{loading ? <span className="home-skeleton home-skeleton--number"></span> : formatNumber(card.value)}</strong>
                  <span className={card.value ? 'has-value' : ''}>{card.note}</span>
                </div>
              </article>
            ))}
          </section>

          <div className="home-primary-grid">
            <section className="home-panel home-chart-panel" aria-labelledby="home-chart-title">
              <header className="home-panel__header">
                <div>
                  <p className="home-panel__eyebrow">7 ngày gần nhất</p>
                  <h2 id="home-chart-title">Nhịp hội thoại</h2>
                </div>
                <div className="home-chart-legend" aria-label="Chú thích biểu đồ">
                  <span><i className="is-conversation"></i> Khách hàng</span>
                  <span><i className="is-ai"></i> AI xử lý</span>
                </div>
              </header>
              {loading ? <div className="home-chart-loading"><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div> : this.renderChart(summary.series || [])}
              {!loading && dataLevel === 'sparse' && <p className="home-sparse-note"><i className="far fa-info-circle" aria-hidden="true"></i> Dữ liệu còn ít; xu hướng sẽ rõ hơn khi có thêm hội thoại.</p>}
            </section>

            <aside className="home-panel home-quick-setup" aria-labelledby="home-setup-title">
              <header className="home-panel__header">
                <div>
                  <p className="home-panel__eyebrow">Gợi ý theo trạng thái</p>
                  <h2 id="home-setup-title">Thiết lập nhanh</h2>
                </div>
              </header>
              <div className="home-action-list">
                {ACTIONS.map((action) => (
                  <Link className={`home-action ${setup[action.key] ? 'is-complete' : ''}`} to={action.link} key={action.key}>
                    <span className={`home-action__icon home-action__icon--${action.tone}`}>
                      {setup[action.key]
                        ? <i className="far fa-check" aria-hidden="true"></i>
                        : action.iconSrc
                          ? <img src={action.iconSrc} alt="" />
                          : action.icon}
                    </span>
                    <span className="home-action__copy">
                      <strong>{action.title}</strong>
                      <small>{setup[action.key] ? 'Đã thiết lập' : action.description}</small>
                    </span>
                    <i className="far fa-arrow-right home-action__arrow" aria-hidden="true"></i>
                  </Link>
                ))}
              </div>
            </aside>
          </div>

          <div className="home-secondary-grid">
            <section className="home-panel home-channels" aria-labelledby="home-channel-title">
              <header className="home-panel__header">
                <div>
                  <p className="home-panel__eyebrow">Kết nối đa kênh</p>
                  <h2 id="home-channel-title">Tình trạng kênh</h2>
                </div>
                <Link to="/channel/fanpage">Quản lý kênh</Link>
              </header>
              <div className="home-channel-list">
                {(summary.channels || []).length ? summary.channels.map((channel) => (
                  <div className="home-channel" key={channel.key}>
                    <span className={`home-channel__icon home-channel__icon--${channel.key}`}>
                      {CHANNEL_ASSETS[channel.key] ? <img src={CHANNEL_ASSETS[channel.key]} alt="" /> : '•'}
                    </span>
                    <span className="home-channel__name">{channel.label}</span>
                    <span className={`home-channel__status ${channel.active ? 'is-active' : ''}`}><i></i>{channel.active ? `${channel.active} đang hoạt động` : 'Chưa kết nối'}</span>
                  </div>
                )) : ['facebook', 'zalo', 'webchat'].map((key) => (
                  <div className="home-channel" key={key}>
                    <span className={`home-channel__icon home-channel__icon--${key}`}>
                      <img src={CHANNEL_ASSETS[key]} alt="" />
                    </span>
                    <span className="home-channel__name">{TYPE_LABELS[key]}</span>
                    <span className="home-channel__status"><i></i>Chưa kết nối</span>
                  </div>
                ))}
              </div>
            </section>

            <section className="home-panel home-activity" aria-labelledby="home-activity-title">
              <header className="home-panel__header">
                <div>
                  <p className="home-panel__eyebrow">Cập nhật gần đây</p>
                  <h2 id="home-activity-title">Hoạt động khách hàng</h2>
                </div>
                {(summary.recent_activity || []).length > 0 && <Link to="/chat">Xem tất cả</Link>}
              </header>
              {(summary.recent_activity || []).length ? (
                <div className="home-activity-list">
                  {summary.recent_activity.map((item) => (
                    <Link className="home-activity-item" to={`/chat/${item.contact_id}`} key={item.contact_id}>
                      {item.picture ? <img src={item.picture} alt="" /> : <span className="home-activity-item__avatar">{(item.name || 'K').charAt(0).toUpperCase()}</span>}
                      <span className="home-activity-item__copy"><strong>{item.name}</strong><small>{item.snippet}</small></span>
                      <time>{formatRelativeTime(item.last_time)}</time>
                    </Link>
                  ))}
                </div>
              ) : <ActivityEmpty />}
            </section>
          </div>
        </div>
      </main>
    );
  }
}
